<template>
    <div class="swiper-banner" v-if="bannerList.length">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="item in bannerList" :key="item.imageInputs" @click="goDetail(item.id)">
          <img class="img" :src="item.imageInputs" alt="">
        </van-swipe-item>
      </van-swipe>
</div>
</template>
<script>
export default {
    data(){
        return {
          bannerList:[],
        }
    },
    mounted(){
       this.getBanner()
    },
    methods:{
      getBanner(){
        let that = this
        that.http.get('/api/front/article/banner/gwList').then((res)=>{
            this.bannerList = res.data.data.list       
        })
      },
      goDetail(id){
        this.$router.push({
            path: '/detail',
            query: {
              id:id
            }
        })
      },
    }
}
</script>
<style lang="less" scoped>
  .my-swipe .van-swipe-item {
    text-align: center;
    height: 3.44rem;
    width: 100%;
    background-color: #f5f5f5;
  }
  .my-swipe .img{
    max-height: 100%;
    max-width: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/components/banner.vue